(function () {

    'use strict';

    angular.module('FotocApp')

        .component('switch', {
          
            bindings: {
                ngModel: '=',
                items:'<',
                values:'<'
            },
            template: '<div class="item" ng-repeat="item in $ctrl.items" ng-click="$ctrl.doClick($index)" ng-class="{active: $ctrl.pos == $index}">{{item}}</div><div class="m" style="left: {{((100/$ctrl.items.length)*$ctrl.pos)}}%"><i class="fas fa-caret-down"></i></div>',
            controller: ['$scope','$element','$canvasService', function ($scope, $element, $editorService) {

                var self = this;
                this.$editorService = $editorService;
                this.pos = 0;

                this.$onInit = function () {  
                    
                    $scope.$watch('$ctrl.ngModel', function (a, b){

                        if(angular.isDefined(self.values)){
                            if(angular.isDefined(a))  self.pos = self.values.indexOf(parseInt(a), 0);
                           
                
                        }else{
                            if(angular.isDefined(a))  self.pos = self.items.indexOf(a);
                        }
                      
                        
                    })

                }

                this.doClick = function($item){
                    if(angular.isDefined(this.values)){
                       
                        this.ngModel = self.values[$item];
                       
                    }else{
                        this.ngModel = this.items[$item];
                    }
                    
                }


            }]
        
        })




})(); 